/**
 * Проверяет является ли переданное значение строкой.
 *
 * @param value Значение, которое нужно проверить.
 * @returns true, если переданное значение является строкой, иначе false.
 * @example
 * ```typescript
 * import { isString } from '@direct-frontend/stdlib';
 *
 * isString(''); // true
 * isString('A'); // true
 * isString(1); // false
 * ```
 */
export function isString(value) {
    return typeof value === 'string';
}
